import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import SetupKonva from "../../../OfflineSetup/OfflineSetupControl/OfflineSetupControlKonva/OfflineSetupControlKonva";
import IROfflineForm from "./IROfflineForm";
import { getData } from "../../../../utils/IndexedDB";
import { useParams } from "react-router-dom";

export default function IROfflineControl() {
	const [formBody, setFormBody] = useState(null);
	const [formEditData, setFormEditData] = useState(null);
	const [roomId, setRoomId] = useState(null);
	const param = useParams();
	useEffect(() => {
		const initDB = async () => {
			try {
				const data = await getData(
					"OfflineModeData",
					"configurationStore",
					"configuration",
				);

				setFormBody(data);
			} catch (error) {
				console.error("IndexedDB read error:", error);
			}
		};

		initDB();
	}, []);
	useEffect(() => {
		const initDB = async () => {
			try {
				if (param.id) {
					const irData = await getData("OfflineModeData", "IR", param.id);
					setFormEditData(irData);
				}
			} catch (error) {
				console.error("IndexedDB read error:", error);
			}
		};

		initDB();
	}, [param.id]);
	return (
		<div>
			<Helmet>
				<title>IR-Offline-Control</title>
				<meta name="description" content="Offline Setup" />
			</Helmet>

			<div className="container-fluid">
				<div className="row">
					<SetupKonva
						col="col-lg-7"
						floorplan={formBody?.layoutUrlBase64}
						rooms={formBody?.rooms}
						setUniqueId={setRoomId}
						roomId={roomId}
						// setUniqueId={setUniqueId}
					/>
					<IROfflineForm
						formBody={formBody}
						formEditData={formEditData}
						setRoomId={setRoomId}
						roomId={roomId}
					/>
				</div>
			</div>
		</div>
	);
}
